import React from 'react';
import Dialog from '../../components/Dialog';
import UserForm from './UserForm';
import { UserFormData } from '../../pages/user-form-types';
import { RoleFormData } from '../../pages/user-form-types';
import { FormErrors } from './types';
import { Local as LookupLocal, Province } from '../../services/lookups.service';

interface UserFormDialogProps {
    isOpen: boolean;
    title: string;
    formData: UserFormData;
    errors: FormErrors;
    roles: RoleFormData[];
    provinces: Province[];
    filteredLocals: LookupLocal[];
    showRegionLocal: boolean;
    isSubmitting: boolean;
    onClose: () => void;
    onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    onRoleSelect: (value: string) => void;
    onRegionSelect: (selected: string[]) => void;
    onLocalSelect: (selected: string[]) => void;
    onSubmit: () => void;
}

const UserFormDialog: React.FC<UserFormDialogProps> = ({
    isOpen,
    title,
    formData,
    errors,
    roles,
    provinces,
    filteredLocals,
    showRegionLocal,
    isSubmitting,
    onClose,
    onInputChange,
    onRoleSelect,
    onRegionSelect,
    onLocalSelect,
    onSubmit
}) => {
    return (
        <Dialog
            id="add-user-dialog"
            title={title}
            isOpen={isOpen}
            onClose={onClose}
            width="w-[95%] sm:w-[600px] md:w-[700px] lg:w-[500px]"
            padding="px-3 py-4 sm:px-4 sm:py-5 md:px-10 md:py-8 lg:px-6 lg:py-6"
        >
            <UserForm
                formData={formData}
                errors={errors}
                roles={roles}
                provinces={provinces}
                filteredLocals={filteredLocals}
                showRegionLocal={showRegionLocal}
                isSubmitting={isSubmitting}
                onInputChange={onInputChange}
                onRoleSelect={onRoleSelect}
                onRegionSelect={onRegionSelect}
                onLocalSelect={onLocalSelect}
                onSubmit={onSubmit}
            />
        </Dialog>
    );
};

export default UserFormDialog;
